import React from "react";
import { useMatchData } from "../../../../mls-match-list/utils";
import { StyledSponsorWrapper } from "./StyledSupportCopyCompact";
import SponsorV2 from "../SponsorV2";

function SupportCopyLogo() {
  const { promoInfo } = useMatchData();
  const { sponsorImage, promotionalSponsor } = promoInfo;
  const { assetUrl } = sponsorImage || {};

  return (
    <StyledSponsorWrapper className="mls-c-support-copy__sponsor-logo">
      <SponsorV2
        hasPresBy={false}
        templateUrl={assetUrl}
        url={promotionalSponsor?.url}
        accessibleText={promotionalSponsor?.accessibleText}
        openInNewTab={promotionalSponsor?.openInNewTab}
      />
    </StyledSponsorWrapper>
  );
}

export default SupportCopyLogo;
